// GDPR Data Subject Rights endpoints under /v1/me.
//
// Wire shape mirrors backend/app/api/v1/me.py:
//   GET  /v1/me/export → Article 15. 200 with inline JSON bundle when small
//        (<=1 MiB), otherwise 202 + a task id (worker emails a download link).
//   POST /v1/me:delete → Article 17. Always 202 (idempotent).

import { api } from '@/lib/api';

export interface ExportResult {
  // true when the bundle was returned inline and downloaded in the browser;
  // false when the server queued an async export (email delivery).
  inline: boolean;
}

export async function exportMyData(): Promise<ExportResult> {
  const resp = await api.get('/me/export', { responseType: 'blob' });

  // 202 => async; worker emails a presigned link. Nothing to download now.
  if (resp.status === 202) {
    return { inline: false };
  }

  const blob = resp.data as Blob;
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `dagsight-export-${new Date().toISOString().slice(0, 10)}.json`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
  return { inline: true };
}

export interface DeleteAccountResult {
  status: string;
  message: string;
  estimated_completion: string;
}

export async function deleteMyAccount(): Promise<DeleteAccountResult> {
  // Literal ":delete" in the path — not a path param. baseURL auto-prefixes /v1.
  const resp = await api.post<DeleteAccountResult>('/me:delete');
  return resp.data;
}
